import React, { useEffect, useRef } from 'react';
import { PhaserGame } from '../phaser';

const GameTestPage: React.FC = () => {
  const gameContainerRef = useRef<HTMLDivElement>(null);
  const phaserGameRef = useRef<PhaserGame | null>(null);

  useEffect(() => {
    if (gameContainerRef.current && !phaserGameRef.current) {
      try {
        // Khởi tạo Phaser game
        phaserGameRef.current = new PhaserGame(gameContainerRef.current);
        
        // Bắt đầu game cloud-tower
        phaserGameRef.current.startGame('cloud-tower');
      } catch (error) {
        console.error('Error initializing game:', error);
      }
    }

    // Cleanup khi component unmount
    return () => {
      if (phaserGameRef.current) {
        phaserGameRef.current.destroy();
        phaserGameRef.current = null;
      }
    };
  }, []);

  return (
    <div style={{ 
      overflow: 'hidden',
      background: '#000' // Black background
    }}>
      <div 
        ref={gameContainerRef} 
        style={{ 
          width: '100%',
          height: '100%'
        }}
      />
    </div>
  );
};

export default GameTestPage;
